import { IDmBoMon } from "../../../model/response/category/IDmBoMon";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eBoMonActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDmBoMon[],
    LOAD_ERROR: "",

}
export const eBoMonActionIds = generateActionTypeIds(eBoMonActionsObj, "BO_MON");
export type IBoMonActionTypes = IGenericActionType<typeof eBoMonActionsObj, "BO_MON">;